/* VINOD cart behaviour — quantity and remove without a page reload.
   Uses /cart/change.js with the line index, then re-renders this section through the
   Section Rendering API so every derived figure (slab, free shipping, savings, totals)
   comes back from Liquid rather than being recalculated in two places. */
(function () {
  'use strict';

  var SECTION = 'vinod-cart';

  function root() { return document.querySelector('[data-vd-cart]'); }

  function refresh() {
    var url = window.location.pathname + '?section_id=' + SECTION;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-vd-cart]');
        var current = root();
        if (next && current) current.replaceWith(next);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  function change(line, qty) {
    var el = root();
    if (el) el.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { return refresh(); })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vd-qty]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-vd-qty'), 10);
    var to = parseInt(btn.getAttribute('data-vd-to'), 10);
    if (isNaN(line) || isNaN(to) || to < 0) return;
    change(line, to);
  });
})();
